import { IStatusValue } from '../../shared/components/gmc-status-input/gmc-status-input.component';
import { ILanguage } from './language';
import { IHiringOn } from './hiring-on';
import { EmployerJobExperience, IEmployerJobExperience } from './employer-job-experience';
import { CompanyData, ICompanyData } from './company-data';
import { EmployerPersonalData } from './employer-personal-data';

export interface IEmployerInfo {
  _id?: string;
  photo?: string;
  personal_phone?: IStatusValue[];
  personal_email?: IStatusValue[];
  city?: string;
  country?: string;
  first_name?: string;
  last_name?: string;
  languages?: ILanguage[];
  current_vacancies?: any[];
  employer_company?: ICompanyData;
  hiring_on?: IHiringOn[];
  job_experience?: IEmployerJobExperience[];
  role?: number;
}

export class EmployerInfo {
  _id: string;
  photo: string;
  current_vacancies: any[];
  employer_company: CompanyData;
  hiring_on: IHiringOn[];
  job_experience: EmployerJobExperience[];
  personal_info: EmployerPersonalData;
  company_info: CompanyData;
  role: number;

  constructor( data: IEmployerInfo = {} ) {
    this._id = data._id;
    this.photo = data.photo;
    this.current_vacancies = data.current_vacancies;
    this.hiring_on = data.hiring_on;
    this.job_experience = data.job_experience.map(
      (value: IEmployerJobExperience) =>
        new EmployerJobExperience(value)
    )
      .sort((a, b) => {
        return (a.date_end ? a.date_end.unix() : 0) <
        (b.date_end ? b.date_end.unix() : 0)
          ? 1
          : (a.date_end ? a.date_end.unix() : 0) >
          (b.date_end ? b.date_end.unix() : 0)
            ? -1
            : 0;
      });
    this.personal_info = new EmployerPersonalData(data);
    this.company_info = new CompanyData(data.employer_company);
    this.role = data.role;
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/employer-info.ts